import services from "../services";

export const transactionEnquiryActions = {
  getTransactionEnquiry,
  getTransactionsForReject,
  rejectTransaction,
  processPendingApproval,
  searchUpcomingRejectsRecalls,
  searchRecallRejectHistory,
  searchRecallPendingApprovals,
  recallTransaction
};

function getTransactionEnquiry(values, props) {
  return services.transactionEnquiryService.getTransactionEnquiry(
    values,
    props
  );
}

function getTransactionsForReject(values, props) {
  return services.transactionEnquiryService.getTransactionsForReject(
      values,
      props
  );
}

function rejectTransaction(values, props) {
  return services.transactionEnquiryService.rejectTransaction(
      values,
      props
  );
}

function processPendingApproval(values, props) {
  return services.transactionEnquiryService.processPendingApproval(
      values,
      props
  );
}

function searchUpcomingRejectsRecalls(values, props) {
  return services.upcomingRecallsRejectsService.searchUpcomingRejectsRecalls(values, props);
}

function searchRecallRejectHistory(values, props) {
  return services.transactionEnquiryService.searchRecallRejectHistory(values, props);
}

function searchRecallPendingApprovals(values, props) {
  return services.transactionEnquiryService.searchRecallPendingApprovals(values, props);
}

function recallTransaction(values, props) {
  return services.transactionEnquiryService.recallTransaction(
      values,
      props
  );
}
  
